<template>
  <div id="glass-units-table" @mouseleave="glassUnitExit">
    <div class="table-wrapper">
      <span class="table-name">{{$t('product_glass_units_table.glass_units')}}</span>
      <div class="rTable">
        <div class="rTableRow problem-header">
          <div
            class="rTableHead text-cell"
            v-for="(header, i) in headers"
            :key="i"
            :style="{ 'width': header.width + '%'}"
          >{{header.text}}</div>
        </div>
        <div
          class="rTableRow"
          v-for="(glassUnit, i ) in product.glass_units"
          :key="i"
          :class="{ 'highlighted-row': glassUnit.highlighted}"
          @mouseenter="selectGlassUnit(glassUnit)"
        >
          <div class="rTableCell">{{i+1}}.</div>
          <div class="rTableCell">{{glassUnit.description}}</div>
          <div class="rTableCell">{{glassUnit.type}}</div>
          <div class="rTableCell">{{glassUnit.field}}</div>
          <div class="rTableCell number-cell">{{glassUnit.width}}</div>
          <div class="rTableCell number-cell">{{glassUnit.height}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "product-glass-units-table",
  props: ["product"],
  data() {
    return {
      loading: false,
      headers: [
        {
          text: this.$t("product_glass_units_table.number"),
          width: 5
        },
        {
          text: this.$t("product_glass_units_table.name"),
          width: 45
        },
        {
          text: this.$t("product_glass_units_table.formula"),
          width: 30
        },
        {
          text: this.$t("product_glass_units_table.position"),
          width: 10
        },
        {
          text: this.$t("product_glass_units_table.width"),
          width: 5
        },
        {
          text: this.$t("product_glass_units_table.height"),
          width: 5
        }
      ]
    };
  },
  methods: {
    selectGlassUnit(glassUnit) {
      this.$emit("glassUnitViewed", glassUnit.field);
    },
    glassUnitExit() {
      this.$emit("glassUnitExit");
    },
    highlightRow(code) {
      for (const glassUnit of this.product.glass_units) {
        if (glassUnit.field == code) {
          glassUnit.highlight();
        } else {
          glassUnit.removeHighlight();
        }
      }
    },
    removeHighlights() {
      for (const glassUnit of this.product.glass_units) {
        glassUnit.removeHighlight();
      }
    }
  }
};
</script>

<style>
.table-name {
  font-size: 16px;
  font-weight: bold;
}
.highlighted-row {
  background: #14c944;
}
</style>